import { render, staticRenderFns } from "./NoticesList.vue?vue&type=template&id=3a7c9cbc"
import script from "./NoticesList.vue?vue&type=script&lang=js"
export * from "./NoticesList.vue?vue&type=script&lang=js"
import style0 from "./NoticesList.vue?vue&type=style&index=0&id=3a7c9cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports